module.exports = __webpack_public_path__ + "media/images/patent/x_1-54376e511fb748460c7e1e9d2c5eba58.png";